import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5206b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mxa-header-icon-svg",
  viewBox: "0 0 20 20",
  width: "50",
  height: "50"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    stroke: "white",
    "stroke-width": "1.2",
    cx: "10",
    cy: "10",
    r: "9"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "white",
    cx: "10.44",
    cy: "14.42",
    r: "1.2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "white",
    "stroke-width": "1.2",
    d: "M8.17,7.79 C8.17,4.75 12.72,4.73 12.72,7.72 C12.72,8.67 11.81,9.15 11.23,9.75 C10.75,10.24 10.51,10.73 10.45,11.4 C10.44,11.53 10.43,11.64 10.43,11.75"
  })
], -1))

import ROUTER_TYPE from '@/router/routeType'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheHeaderHelp',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _unref(ROUTER_TYPE).HELP,
    target: "_blank",
    class: "mxa-header-icon",
    title: _ctx.$t('header.help.title'),
    "data-test": "header_title"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["to", "title"]))
}
}

})